"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventResolutionType = exports.EventResolutionTypes = exports.DailyRoutePlanStatusType = exports.DailyRoutePlanStatusTypes = exports.DeliveryPickupPlannedStopStatusLabels = exports.DeliveryPickupPlannedStopStatus = exports.DeliveryPickupPlannedStopStatuses = exports.RoutePlanStopStatusTypeLabels = exports.RoutePlanStopStatusType = exports.RoutePlanStopStatusTypes = exports.PickupCycleUnit = exports.PickupCycleUnits = exports.CommercialTermUnit = exports.CommercialTermUnits = exports.CommercialSubscriptionStatusLabels = exports.CommercialSubscriptionStatus = exports.CommercialSubscriptionStatuses = exports.DeliveryPickupRouteEventType = exports.DeliveryPickupRouteEventTypes = exports.SubscriptionEquipmentStatus = exports.SubscriptionEquipmentStatuses = exports.PriceBasisType = exports.PriceBasisTypes = exports.PriceUnitType = exports.PriceUnitTypes = exports.LineItemRecurrenceType = exports.LineItemRecurrenceTypes = exports.StopType = exports.StopTypes = exports.StopFrequency = exports.StopFrequencies = exports.RouteEventType = exports.RouteEventTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RouteEventTypes = [
    'PICKUP_SUCCESS',
    'PICKUP_WITH_ISSUE',
    'PICKUP_FAILURE',
    'DUMP_SUCCESS',
    'DUMP_WITH_ISSUE',
    'DUMP_FAILURE',
];
exports.RouteEventType = typebox_1.Type.Union(exports.RouteEventTypes.map((type) => typebox_1.Type.Literal(type)));
exports.StopFrequencies = ['WEEKLY', 'BIWEEKLY', 'MONTHLY'];
exports.StopFrequency = typebox_1.Type.Union(exports.StopFrequencies.map((type) => typebox_1.Type.Literal(type)));
exports.StopTypes = [
    'CUSTOMER_DELIVERY', // For delivery of a container
    'CUSTOMER_REMOVAL', // For removal of a container
    'CUSTOMER_PICKUP', // For pickup on the contents of a container (the container stays)
    'CUSTOMER_DOUBLE_PICKUP',
    'CUSTOMER_DOUBLE_PICKUP_DRIVER',
    'DISPOSAL',
    'WAYPOINT',
    'YARD',
];
exports.StopType = typebox_1.Type.Union(exports.StopTypes.map((type) => typebox_1.Type.Literal(type)));
exports.LineItemRecurrenceTypes = [
    'INITIAL', // Applied on the first bill only
    'RECURRING', // Applied on every bill
    'SPECIAL', // Applied once on an arbitrary bill in the middle of a subscription
];
exports.LineItemRecurrenceType = typebox_1.Type.Union(exports.LineItemRecurrenceTypes.map((type) => typebox_1.Type.Literal(type)));
exports.PriceUnitTypes = [
    'DISCREET', // The quantity is a count. This would apply to things like 'per container' or 'per pickup'
    'CONTINUOUS', // The quantity is a weight or volume. This would apply to things like 'per ton' or 'per cubic yard'
];
exports.PriceUnitType = typebox_1.Type.Union(exports.PriceUnitTypes.map((type) => typebox_1.Type.Literal(type)));
exports.PriceBasisTypes = ['FIXED', 'QUANTITY', 'PERCENT'];
exports.PriceBasisType = typebox_1.Type.Union(exports.PriceBasisTypes.map((type) => typebox_1.Type.Literal(type)));
// These statuses used to be part of CommercialSubscriptionStatuses, but are now possible status values for
// SubscriptionEquipment.
exports.SubscriptionEquipmentStatuses = [
    'DELIVERY_UNASSIGNED',
    'DELIVERY_SCHEDULED',
    'PARTIALLY_DELIVERED', //For multi-container situations where some containers have been delivered and some have not
    'ADDITIONAL_DELIVERY_UNASSIGNED', // For additional containers added to a subscription, or for additional containers that need to arrive in multiple trips
    'ADDITIONAL_DELIVERY_SCHEDULED', // For additional containers added to a subscription, or for additional containers that need to arrive in multiple trips
    'ON_SITE',
    'REMOVAL_UNASSIGNED',
    'REMOVAL_SCHEDULED',
    'PARTIALLY_REMOVED', // For multi-container situations where some containers have been removed and some have not
    'REMOVAL_COMPLETED',
];
exports.SubscriptionEquipmentStatus = typebox_1.Type.Union(exports.SubscriptionEquipmentStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.DeliveryPickupRouteEventTypes = [
    'DELIVERY_SUCCESS',
    'DELIVERY_WITH_ISSUE',
    'DELIVERY_FAILURE',
    'REMOVAL_SUCCESS',
    'REMOVAL_WITH_ISSUE',
    'REMOVAL_FAILURE',
];
exports.DeliveryPickupRouteEventType = typebox_1.Type.Union(exports.DeliveryPickupRouteEventTypes.map((type) => typebox_1.Type.Literal(type)));
exports.CommercialSubscriptionStatuses = ['CANCELLED', 'SUSPENDED', 'PAUSED', 'ACTIVE'];
exports.CommercialSubscriptionStatus = typebox_1.Type.Union(exports.CommercialSubscriptionStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.CommercialSubscriptionStatusLabels = {
    CANCELLED: {
        wayste: 'Canceled',
    },
    SUSPENDED: {
        wayste: 'Suspended',
    },
    PAUSED: {
        wayste: 'Paused',
    },
    ACTIVE: {
        wayste: 'Active',
    },
};
exports.CommercialTermUnits = ['DAYS', 'WEEKS', 'MONTHS', 'YEARS'];
exports.CommercialTermUnit = typebox_1.Type.Union(exports.CommercialTermUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.PickupCycleUnits = ['DAYS', 'WEEKS', 'MONTHS'];
exports.PickupCycleUnit = typebox_1.Type.Union(exports.PickupCycleUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.RoutePlanStopStatusTypes = ['PENDING', 'EN_ROUTE', 'COMPLETED', 'ISSUE'];
exports.RoutePlanStopStatusType = typebox_1.Type.Union(exports.RoutePlanStopStatusTypes.map((val) => typebox_1.Type.Literal(val)));
exports.RoutePlanStopStatusTypeLabels = {
    PENDING: {
        singular: 'Not started',
    },
    EN_ROUTE: {
        singular: 'En route',
    },
    COMPLETED: {
        singular: 'Completed',
    },
    ISSUE: {
        singular: 'Issue',
    },
};
exports.DeliveryPickupPlannedStopStatuses = [
    'UNASSIGNED',
    'ASSIGNED',
    'IN_PROGRESS',
    'INCOMPLETE',
    'FAILED',
    'COMPLETED',
];
exports.DeliveryPickupPlannedStopStatus = typebox_1.Type.Union(exports.DeliveryPickupPlannedStopStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.DeliveryPickupPlannedStopStatusLabels = {
    UNASSIGNED: {
        wayste: 'Unassigned',
    },
    ASSIGNED: {
        wayste: 'Assigned',
    },
    IN_PROGRESS: {
        wayste: 'In progress',
    },
    INCOMPLETE: {
        wayste: 'Incomplete',
    },
    FAILED: {
        wayste: 'Failed',
    },
    COMPLETED: {
        wayste: 'Completed',
    },
};
exports.DailyRoutePlanStatusTypes = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'ISSUE'];
exports.DailyRoutePlanStatusType = typebox_1.Type.Union(exports.DailyRoutePlanStatusTypes.map((val) => typebox_1.Type.Literal(val)));
exports.EventResolutionTypes = ['ISSUE', 'RESOLUTION'];
exports.EventResolutionType = typebox_1.Type.Union(exports.EventResolutionTypes.map((val) => typebox_1.Type.Literal(val)));
//# sourceMappingURL=enums.js.map